import { render } from "./Create.vue?vue&type=template&id=a9e97cdc"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=a9e97cdc&lang=css"
script.render = render

export default script